// ==================================================================================================
//
//  Check if back end error exists on page reload
//  If so, scroll to it
//
// ==================================================================================================
const formScrollToBackendError = () => {
  let props = {};
  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$form = $('.js-form-validate')
    return;
  }

  // Close flash message
  // ------------------------------------------------
  const checkForBackendError = () => {
    if (els.$form.find('#error_explanation').length) {
      const topOffset = els.$form.find('#error_explanation').offset().top

      $('html, body').animate({
        scrollTop: topOffset
      }, 500)
    }
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    setTimeout(() => {
      checkForBackendError()
    }, 500)

    props.isEnabled = true;

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here

    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
    return;
  }

  return {
    init,
    enable,
    disable
  };
}

export default formScrollToBackendError;
